// Service for Manual Attendance Registration
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_RegisterManualAttendanceIn,
  LC_RegisterManualAttendanceOut,
} from '../types';


export class ManualAttendanceRegisterService {
  async register(
    input: LC_RegisterManualAttendanceIn,
  ): Promise<ApiResponse<LC_RegisterManualAttendanceOut>> {
    const { employeeId, ...bodyData } = input;
    
    return apiClient.post<LC_RegisterManualAttendanceOut>(
      API_CONFIG.ENDPOINTS.ATTENDANCE.REGISTER_MANUAL(employeeId),
      bodyData,
    );
  }
}

export const manualAttendanceRegisterService = new ManualAttendanceRegisterService();
